<template>
  <div>
    <index-header></index-header>
    <router-view></router-view>
    <index-footer style="margin-top:120px"></index-footer>
  </div>
</template>

<script>
import indexHeader from "../compents/Header";
import indexFooter from "../compents/Footer";
export default {
  components: {
    indexHeader,
    indexFooter
  }
};
</script>

<style scoped lang="scss">
</style>
